import TheiaHero from "../../assets/products/theia/Orion_with_satellites.jpg";
import TheiaTracking from "../../assets/products/theia/SK0006U_SALTAD_tracking.gif";

import React from "react";
import { Link } from "react-router-dom";

export const theiaData = {
  title: "Theia",
  heroCards: [
    {
      title: "100× More Sensitive",
      description: "Our patented Theia algorithm enhances a telescope's ability to detect faint moving objects, outperforming conventional track-before-detect methods by 100 times or more",
    },
    {
      title: "No Prior Knowledge Required",
      description: "With no prior knowledge of an object's trajectory, Theia detects spacecraft or asteroids that would otherwise be invisible",
    },
    {
      title: "Real-Time Detection",
      description: "Autonomous detection and tracking of moving objects with no prior trajectory knowledge. Integrates seamlessly with ground telescopes, star trackers, and space-based systems",
    },
  ],
  content: [
    {
      href: TheiaHero,
    },
    {
      title: "Advanced Space Domain Awareness",
      cards: [
        {
          title: "Patented Detection Algorithm",
          description: "Theia's revolutionary algorithm detects faint moving objects that conventional methods miss, enhancing your telescope's capabilities by orders of magnitude",
        },
        {
          title: "Versatile Platform",
          description: (
            <>
              Boosts the performance of various Space Domain Awareness (SDA) systems, including ground telescopes, star trackers, and specialized space telescopes
            </>
          ),
        },
        {
          title: "Space-Tested Technology",
          description: "Proven performance in space operations, delivering more than 10× improvement in space telescope detection capabilities",
        },
      ],
      href: TheiaTracking,
    },
  ],
};

